import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';
import classNames from 'classnames';

import { ReactComponent as LinkedinIcon } from '../../../assets/images/linkedin-icon.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/images/PhoneIcon.svg';
import { UserAvatar } from '../../UserAvatar/UserAvatar';

import styles from './CandidateInfoSection.module.scss';

export const CandidateInfoSection = ({
  candidateInfo,
  setCurrentStep,
  isEditable = true,
  isLoading,
  customQuestions = [],
}) => {
  const { t } = useTranslation('common');
  return (
    <div className={classNames('space-y-1.5')}>
      <p className={styles.yourInfoLabel}>{t('labels.candidateInfo')}</p>
      <div className={styles.yourInfoContainer}>
        <div className={styles.yourInfoContainerInner}>
          {isLoading ? (
            <ThreeDots height="20" width="32" radius="9" color="#314155" ariaLabel="three-dots-loading" visible />
          ) : (
            <>
              <UserAvatar name={candidateInfo?.first_name} />

              <div className="space-y-2">
                <p className={styles.yourInfoValue}>
                  <span>{`${candidateInfo?.first_name} ${candidateInfo?.last_name}`}</span>
                  <span className={styles.yourInfoValueEmail}>{candidateInfo?.email}</span>
                </p>
                {(candidateInfo?.phone_number || candidateInfo?.linkedin_url) && (
                  <p className={styles.yourInfoValue}>
                    {candidateInfo?.phone_number && (
                      <span className={styles.yourInfoValuePhone}>
                        <span className={styles.yourInfoIconContainer}>
                          <PhoneIcon />
                        </span>
                        {candidateInfo?.phone_number}
                      </span>
                    )}
                    {candidateInfo?.linkedin_url && (
                      <span className={styles.yourInfoValuePhone}>
                        <span className={styles.yourInfoIconContainer}>
                          <LinkedinIcon />
                        </span>
                        {candidateInfo?.linkedin_url.replace('www.linkedin.com/in', '')}
                      </span>
                    )}
                  </p>
                )}
                {customQuestions.length > 0 &&
                  (() => {
                    const questionsWithAnswers = [...customQuestions]
                      .sort((a, b) => a.order - b.order)
                      .filter((question) => {
                        const fieldName = `custom_question_${question.id}` || question.question;
                        const answer = candidateInfo?.[fieldName] || question.answer;

                        if (Array.isArray(answer)) {
                          return answer.length > 0;
                        }
                        return answer && answer.toString().trim() !== '';
                      });

                    if (questionsWithAnswers.length === 0) return null;

                    return (
                      <div className="space-y-1">
                        {questionsWithAnswers.map((question, index) => {
                          const fieldName = `custom_question_${question.id}` || question.question;
                          const answer = candidateInfo?.[fieldName] || question.answer;
                          let formattedAnswer = answer;
                          if (question.fieldType === 'multi_select_dropdown' && Array.isArray(answer)) {
                            formattedAnswer = answer.join(', ');
                          }

                          return (
                            <p key={question.id || `question-${index}`} className={styles.yourInfoValue}>
                              <span className={styles.yourInfoValuePhone}>
                                <strong>
                                  {question.title || question.question}
                                  {question?.title?.endsWith('?') || question?.question?.endsWith('?') ? ' ' : ': '}
                                </strong>{' '}
                                {formattedAnswer}
                              </span>
                            </p>
                          );
                        })}
                      </div>
                    );
                  })()}
              </div>
            </>
          )}
        </div>
        {isEditable && setCurrentStep && (
          <button className={styles.editButton} type="button" onClick={() => setCurrentStep(2)}>
            {t('edit')}
          </button>
        )}
      </div>
    </div>
  );
};
